import React from 'react'
import { Link } from 'react-router'
import { Row, Col, Button, Table } from 'reactstrap';

import { toLocaleDateString } from '../../../utils/date'
import {renderIconSpecialties} from '../../utils'
import { capitalizeFirstLetter } from '../../../utils/parse'


export default class ProfileInfo extends React.Component {

	render(){
		const { provider } = this.props;

		const departements = provider.list_departments.map((dep) => {
            return <div key={dep} className="list-bloc"> {dep} </div>
        });

		return(
			<div className="provider-profile-bloc bloc-1">

				{provider.status === "A" &&
	            	<div className={this.props.responsive ? 'rib-success' : "ribbon ribbon-success"}><p>Approuvé</p></div>
	            }
	            {provider.status === "CA" &&
	            	<div className={this.props.responsive ? 'rib-success' : "ribbon ribbon-success"}><p>En cours</p></div>
	            }
	            {provider.status === "PA" &&
	            	<div className={this.props.responsive ? 'rib-success' : "ribbon ribbon-success"}><p>En cours</p></div>
	            }
	            {provider.status === "RV" &&
	            	<div className={this.props.responsive ? 'rib-success' : "ribbon ribbon-success"}><p>En cours</p></div>
	            }
	            {provider.status === "W" &&
	            	<div className={this.props.responsive ? 'rib-warning' : "ribbon ribbon-warning"} ><p>Stand by</p></div>
	            }
	             {provider.status === "R" &&
	            	<div className={this.props.responsive ? 'rib-danger' : "ribbon ribbon-danger"}><p>Refusé</p></div>
	            }

	            <Row>
	                <Col>
	                    <div className="title">{capitalizeFirstLetter(provider.company)}</div>
	                    <div className="text">{capitalizeFirstLetter(provider.address)}</div>
	                    <div className="text">{provider.zip} {capitalizeFirstLetter(provider.city)}</div>
	                    <div className="text">{capitalizeFirstLetter(provider.last_name)} {capitalizeFirstLetter(provider.first_name)}</div>
	                    <div className="text">{provider.phone}</div>
	                    <div className="text email"><a href={"mailto:"+provider.username}>{provider.username}</a></div>
	                    <div className="specialties-formatter specialties">{renderIconSpecialties(provider.specialties)}</div>
	                </Col>

	                <Col>
	                    <div className="info-admin">
                          	<div className="text-2">Date de la candidature : {toLocaleDateString(provider.created_at)}</div>
	                        <div className="text-2 space-top">SIRET : {provider.siret}</div>
	                        <div className="text-2">Type de l'entreprise : {provider.legal_form}</div>
						  	<div className="text-2">Date création entreprise : {toLocaleDateString(provider.date_company)}</div>
							{provider.rdv && provider.status === "RV" &&
						  		<div className="text-2 space-top">Date RDV : {toLocaleDateString(provider.rdv)} à {provider.rdv_hours}</div>
							}
	                    </div>
	                </Col>

	            </Row>

	            <Row>
	                <Col>
	                    <div className="info-table">

	                    {this.props.responsive &&
	                    	<Table responsive>
		                        <tbody>
                              <tr>
		                            <td className="tt">Interventions</td>
		                          </tr>

		                          <tr>
		                            <td>
		                                <div className="list-bloc">{provider.intervention_planning}</div> de {' '}
		                                <div className="list-bloc">{provider.intervention_time_start}h à {provider.intervention_time_end}h</div>
		                            </td>
		                          </tr>

		                          <tr>
		                            <td className="tt">Tarifs</td>
		                          </tr>
		                          <tr>
		                            <td>
		                                <div className="list-bloc">{provider.price_1} €</div> en semaine {'  '} <br/>
		                                <div className="list-bloc">{provider.price_2} €</div> en soirée et samedi {'  '} <br/>
		                                <div className="list-bloc">{provider.price_3} €</div> la nuit, JF et dimanche {'  '}
		                            </td>
		                          </tr>

		                          <tr>
		                            <td className="tt lst">Salariés</td>
		                          </tr>
		                          <tr>
		                            <td className="lst">
		                                <div className="list-bloc">{provider.administratives_number}</div> administratif(s) {'  '}
		                                <div className="list-bloc">{provider.technicians_number}</div> technicien(s) {'  '}
		                            </td>
		                          </tr>

			                        {provider.rdv && provider.status === "RV" &&
			                          <tr>
			                            <td className="tt lst">Rendez-vous</td>
			                          </tr>
		                          	}

		                          	{provider.rdv && provider.status === "RV" &&
			                          <tr>
			                            <td className="lst" >
			                                le <div className="list-bloc">{toLocaleDateString(provider.rdv)}</div>
			                                à <div className="list-bloc">{provider.rdv_hours}</div>
			                                au <div className="list-bloc">{provider.rdv_place}</div>
			                            </td>
			                          </tr>
		                          	}

		                        </tbody>
	                      </Table>
	                    }

	                    {!this.props.responsive &&
	                     <Table responsive>
	                        <tbody>
	                          <tr>
	                            <td className="tt">Interventions</td>
	                            <td>
	                                <div className="list-bloc">{provider.intervention_planning}</div> de {' '}
	                                <div className="list-bloc">{provider.intervention_time_start}h à {provider.intervention_time_end}h</div>
	                            </td>
	                          </tr>
	                          <tr>
	                            <td className="tt">Tarifs</td>
	                            <td>
	                                <div className="list-bloc">{provider.price_1} €</div> en semaine {'  '}
	                                <div className="list-bloc">{provider.price_2} €</div> en soirée et samedi {'  '}
	                                <div className="list-bloc">{provider.price_3} €</div> la nuit, JF et dimanche {'  '}
	                            </td>
	                          </tr>

	                          <tr>
	                            <td className="tt lst">Salariés</td>
	                            <td className="lst" >
	                                <div className="list-bloc">{provider.administratives_number}</div> administratif(s) {'  '}
	                                <div className="list-bloc">{provider.technicians_number}</div> technicien(s) {'  '}
	                            </td>
	                          </tr>

	                          {provider.rdv && provider.status === "RV" &&
		                          <tr>
		                            <td className="tt lst">Rendez-vous</td>
		                            <td className="lst" >
		                                le <div className="list-bloc">{toLocaleDateString(provider.rdv)}</div>
		                                à <div className="list-bloc">{provider.rdv_hours}</div>
		                                au <div className="list-bloc">{provider.rdv_place}</div>
		                            </td>
		                          </tr>
	                          }

	                        </tbody>
	                      </Table>
	                  	}

	                    </div>
	                </Col>
	            </Row>
	        </div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/provider/components/profile/ProfileInfo.js